<template>
    <div>
        <b-button id="popover-target-1" variant="light" class="h-100">
            <i class="fa-regular fa-circle-question"></i>
        </b-button>
        <b-popover target="popover-target-1" triggers="hover" placement="left">
            <template #title>
                Key map
            </template>
            <div class="d-flex flex-column">
                <template v-for="(item,i) of info">
                    <div class="d-flex flex-row mb-1" :key="i">
                        <b-button variant="outline-secondary">{{ item.key }}</b-button>
                        <div class="m-tb-auto ml-1">{{ item.desc }}</div>
                    </div>
                </template>
            </div>
        </b-popover>
    </div>

</template>

<script>
export default {
    name: "KeyHelp",
    props: {
        info: Array
    }
}
</script>

<style scoped>

</style>
